module.exports = __webpack_public_path__ + "static/media/Pod_strani.2907064f.md";